import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChildren, QueryList, ViewChild, ElementRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Platform } from '@ionic/angular';
import { QuestionType, UserAnswer, UserAnswerSelected, UserQuestionDTO, UserQuestion } from '../../../../models/check-interface';
import { CheckStorageService } from '../../../../services/check-storage.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { ChecksService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';

@Component({
  selector: 'lib-hygieneplan-tab',
  templateUrl: './hygieneplan-tab.component.html',
  styleUrls: ['./hygieneplan-tab.component.scss']
})
export class HygieneplanTabComponent implements OnInit, OnChanges {

  @Input() questions!: UserQuestion[];
  @Input() checkId!: string;
  @Input() editable!: boolean;
  @Output() emitClickTextarea: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChildren('textarea') textAreasList: QueryList<any>;
  @ViewChild('questionPage') questionPage: ElementRef;

  isCollapsed = true;
  private additionalInfoSelected: any = '';
  private readonly answerTranslationKeys: Record<string, string> = {
    'Ja': 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF',
    'Yes': 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF',
    'CHECK.ANSWERS.YES': 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF',
    'CHECK.REPORT.YES': 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF',
    'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF': 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF',
    'Nein': 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F',
    'No': 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F',
    'CHECK.ANSWERS.NO': 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F',
    'CHECK.REPORT.NO': 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F',
    'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F': 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F',
    'N/A': 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36',
    'NA': 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36',
    'CHECK.ANSWERS.NA': 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36',
    'CHECK.REPORT.NA': 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36',
    'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36': 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36',
    'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36F': 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36',
    'Teilweise': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E',
    'Partial': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E',
    'partial': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E',
    'Partially': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E',
    'CHECK.ANSWERS.PARTIALLY': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E',
    'CHECK.REPORT.PARTIALLY': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E',
    'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E': 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E'
  };
  public form: FormGroup = new FormGroup({
    questions: new FormArray([])
  });

  constructor(
    private formBuilder: FormBuilder,
    private checkStorageService: CheckStorageService,
    private checksService: ChecksService,
    private config: AppConfig,
    public platform: Platform,
    public layoutService: PHBHPLayoutPackageService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.questions && changes['questions'] && changes['questions'].currentValue.length > 0) {
      this.buildForm();
    }
  }

  ngAfterViewInit(): void {
    this.textAreasList?.forEach((textArea: any) => {
      var lines = textArea.nativeElement.value.split('\n').length;
      var maxAreaWidth = textArea.nativeElement.style.width;
      var availableChars = (maxAreaWidth / 16) * 2;
      var availableLines = textArea.nativeElement.value.length / availableChars;
      if (availableLines > lines) {
        lines = availableLines;
      }

      textArea.nativeElement.style.height = (lines * 35) + 'px';
      textArea.nativeElement.style.maxHeight = '105px';
      if (textArea.nativeElement.value && textArea.nativeElement.value.length > 0) {
        textArea.nativeElement.focus();
        textArea.nativeElement.blur();
      }
    });

    this.questionPage.nativeElement.scrollIntoView();
  }

  buildForm() {
    const itemControls = <FormArray>this.form.controls['questions'];
    this.questions = this.questions.sort((a, b) => a.orderNumber - b.orderNumber);
    this.questions?.forEach((item: UserQuestion) => {
      if ( item.isOldVersion === undefined &&  item.userAnswers && item.userAnswers.length > 0) {
        item.isOldVersion = true;
        itemControls.push(this.createCustomerFormGroup(item));
      } else {
        item.isOldVersion = false;
        if (item.skin === 'Input') {
            item.userAnswers = [{
              id: this.layoutService.generateUUID(),
              userQuestionId: item.id,
              statement: '',
              orderNumber: 1
            }]
          } else {
            if (item.userAnswerOptions && item.userAnswerOptions.length > 0) {
              var answerOptions = [...item.userAnswerOptions];
              answerOptions = answerOptions.sort((a, b) => a.position - b.position);
              item.userAnswers = [];
              for (let i = 0; i < answerOptions.length; i++) {
                item.userAnswers.push({
                  id: this.layoutService.generateUUID(),
                  userQuestionId: item.id,
                  statement: answerOptions[i].caption,
                  orderNumber: i + 1
                });
              }
            } else {
              if (item.min != null && item.max != null) {
                item.userAnswers = [];
                for (let i = item.min; i <= item.max; i++) {
                  item.userAnswers.push({
                    id: this.layoutService.generateUUID(),
                    userQuestionId: item.id,
                    statement: i.toString(),
                    orderNumber: i
                  });
                }
              }
            }
        }

        itemControls.push(this.createCustomerFormGroup(item));
      }
    });
  }

  createCustomerFormGroup(item: UserQuestion) {
    if (item.isOldVersion) {
      return this.formBuilder.group({
        answer: [{ value: item.userAnswerSelectedId ? item.userAnswerSelectedId : '', disabled: !this.editable }],
        comment: [{ value: item.comment ? item.comment.replaceAll('<br>', '\n') : '', disabled: !this.editable }]
      });
    } else {
      var selectedAnswer = '';
      if (item.skin === "Input") {
        if (item.userAnswersSelected && item.userAnswersSelected.length > 0) {
          selectedAnswer = item.userAnswersSelected[0].caption;
        }
      } else {
        if (item.userAnswersSelected && item.userAnswersSelected.length > 0) {
          var selectedAnswerItem = item.userAnswers.find((answer: UserAnswer) => answer.statement === item.userAnswersSelected[0].caption);
          selectedAnswer = selectedAnswerItem ? selectedAnswerItem.id : '';
        }
      } 

      return this.formBuilder.group({
        answer: [{ value: selectedAnswer, disabled: !this.editable }],
        comment: [{ value: item.comment ? item.comment.replaceAll('<br>', '\n') : '', disabled: !this.editable }]
      });
    }
  }

  get questionsArray() {
    return this.form.controls["questions"] as FormArray;
  }

  selectInput(userAnswer: UserAnswer, controlPosition: number, question: UserQuestion) {
    const itemControls = <FormArray>this.form.controls['questions'];
    const itemFormGroup = <FormGroup>itemControls.controls[controlPosition];

    if (userAnswer.id === itemFormGroup.controls["answer"].value) {
      itemFormGroup.controls["answer"].setValue("undefined");
    }

    if (!question.isOldVersion) {
      if (question.isMultiOption) {
        const selectedAnswer = question.userAnswersSelected.find((answer: UserAnswerSelected) => answer.caption === userAnswer.statement);
        if (!selectedAnswer) {
          question.userAnswersSelected.push({
            userQuestionId: question.id,
            caption: userAnswer.statement,
            auditCaption: this.layoutService.translateText(this.getStatementText(userAnswer.statement)),
            orderNumber: question.userAnswersSelected.length + 1,
            createdBy: this.config.userData.userId,
            createdDate: new Date()
          });
        } else {
          question.userAnswersSelected = question.userAnswersSelected.filter((answer: UserAnswerSelected) => answer.caption !== userAnswer.statement);
          question.userAnswersSelected.forEach((answer: UserAnswerSelected) => {
            if (answer.orderNumber > selectedAnswer.orderNumber) {
              answer.orderNumber--;
            }
          });
        }
      } else {
        const selectedAnswer = question.userAnswersSelected.find((answer: UserAnswerSelected) => answer.caption === userAnswer.statement);
        if (selectedAnswer) {
          question.userAnswersSelected = [];
        } else {
          question.userAnswersSelected = [];
          question.userAnswersSelected.push({
            userQuestionId: question.id,
            caption: userAnswer.statement,
            auditCaption: this.layoutService.translateText(this.getStatementText(userAnswer.statement)),
            orderNumber: question.userAnswersSelected.length + 1,
            createdBy: this.config.userData.userId,
            createdDate: new Date()
          });
        }
      }
    }

    this.onFocusOutInputEvent(question, controlPosition, userAnswer);
  }

  getSelectedQuestionsCount(): number {
    const selectedCount = this.questionsArray?.controls?.reduce((count, control) => {
      const answer = control?.get('answer')?.value;
      // Verifica si la respuesta no es 'undefined' y no está vacía
      if (answer !== 'undefined' && answer !== '') {
        count++;
      }
      return count;
    }, 0);

    return selectedCount;
  }

  onFocusOutInputEvent(question: any, controlPosition: number, answer: any) {
    const data: UserQuestionDTO = {
      id: question.id,
      statement: question.statement,
      userAnswerSelectedId: question.isOldVersion ? (answer.id === question.userAnswerSelectedId ? null : answer.id) : null,
      comment: question.comment,
      userAnswers: question.isOldVersion ? question.userAnswers : null,
      defaultData: question.defaultData,
      userQuestionnaireId: question.userQuestionnaireId,
      creationDate: question.creationDate,
      sync: 0,
      orderNumber: 0,
      additionalInfo: question.additionalInfo,
      infoSection: question.infoSection,
      infoFormalBasis: question.infoFormalBasis,
      showInfo: question.showInfo,
      showFormalBasis: question.showFormalBasis,
      userAnswersSelected: question.userAnswersSelected,
      questionTypeId: question.questionTypeId
    };

    this.checkStorageService.putUserQuestion(data).subscribe(() => {
      if (question.isOldVersion) {
        this.questions[controlPosition].userAnswerSelectedId = question.userAnswerSelectedId === answer.id ? null : answer.id;
      }

      this.checkStorageService.putCheckUpdatedBy(this.config.checkId, this.config.userData.userId);
      const itemControls = <FormArray>this.form.controls['questions'];
      console.error(itemControls.value);
    });
  }

  onFocusOutTextareaEvent(question: any, pos: number) {
    const formCtrl = <FormArray>this.form.controls['questions'];
    const commentValue = formCtrl.controls[pos].get('comment')?.value;
    const convertCommentValue = commentValue.split('\n').join('<br>');
    question.comment = convertCommentValue;
    this.emitClickTextarea.emit(false);

    this.checkStorageService.putCommentUserQuestion(question.id, question).subscribe(() => {
      question.comment = convertCommentValue;
      this.checkStorageService.putCheckUpdatedBy(this.config.checkId, this.config.userData.userId);
    });
  }

  autoGrowTextZone(e: any) {
    if (e.code === 'Enter') {
      e.target.style.height = (26 + e.target.scrollHeight) + "px";
    }
  }

  clickTextarea() {
    this.emitClickTextarea.emit(true);
  }

  setAdditionalInfo(additionalInfo: string) {
    this.additionalInfoSelected = additionalInfo;
  }
  onClickQuestionInfo(question: UserQuestionDTO) {
    this.isCollapsed = !this.isCollapsed;
    this.additionalInfoSelected = {
      informationSection: question.showInfo ? question.infoSection : "",
      formalBasics: question.showFormalBasis ? question.infoFormalBasis : ""
    };
  }

  getAdditionalInfo(): any {
    return this.additionalInfoSelected ? this.additionalInfoSelected : { informationSection: '', formalBasics: '' };
  }

  openOffcanvas(additionalInfo: string) {
    this.isCollapsed = !this.isCollapsed;
    this.setAdditionalInfo(additionalInfo);
  }

  onchildData(value) {
    switch (value.key) {
      case 'close':
        this.isCollapsed = !this.isCollapsed;
        break;
    }
  }

  getStatementText(statement: string) {
    const normalizedStatement = (statement || '').trim();
    return this.answerTranslationKeys[normalizedStatement] || normalizedStatement;
  }

  showInfoButton(question: UserQuestion): boolean {
    return question.showInfo || question.showFormalBasis;
  }

  isInputQuestion(question: UserQuestion): boolean {
    return question.skin === "Input";
  }

  checkOrRadio(question: UserQuestion): boolean {
    return question.skin === "Checkbox" || question.skin === "Radio";
  }

  onInputAnswerChange(event, question: UserQuestion, controlPosition: number) {
    if(event.target.value.length == 0) {
      question.userAnswersSelected = [];
    }else if (question.userAnswersSelected.length === 0) {
      question.userAnswersSelected.push({
        userQuestionId: question.id,
        caption: event.target.value,
        auditCaption: event.target.value,
        orderNumber: 1
      });
    } else {
      question.userAnswersSelected[0].caption = event.target.value;
      question.userAnswersSelected[0].auditCaption = event.target.value;
    }

    this.onFocusOutInputEvent(question, controlPosition, null)
  }

  isNumericalInput(question: UserQuestion): boolean {
    return question.skin === "Input" && question.onlyNumbers;
  }

  getInputSkin(skin: string): string {
    switch (skin) {
      case 'Star':
        return 'input-star';
      default:
        return '';
    }
  }

  getInputLabelSkin(question, answer?): string {
    return question.userAnswersSelected.some((selectedAnswer: any) => selectedAnswer.caption == answer.statement) ? 'checked' : 'not-checked';
  }

  starSelected(question: any, index: number) {
    return index < (+(question?.userAnswersSelected[0]?.caption ||0));
  }
  getOptionsDisplay(question: UserQuestion): string {
    if(question.isOldVersion) {
      return '';
    }
    if (this.isInputQuestion(question)) {
      return '';
    }
    if ((question.userAnswerOptions && question.userAnswerOptions.length > 0) || question.skin === "Star") {
      return 'questions-display';
    } else {
      return 'scale-display';
    }
  }

  isStarActive(answer: UserAnswer, question: UserQuestion): boolean {
    if (question.userAnswersSelected.length === 0) {
      return false;
    }

    var selectedValue = parseInt(question.userAnswersSelected[0].caption);
    var answerValue = parseInt(answer.statement);
    return selectedValue >= answerValue;
  }
}
